module.exports = __webpack_public_path__ + "static/4-4bb4ba71ab1f4d60cf36bb930966daa4.jpg";